import {apiUrl} from "../../../setting";


export const getorderListUrl = () => {
    return `${apiUrl}/orderList`;
};

export const paymentGroupByPaymentMethodUrl = () => {
    return `${apiUrl}/paymentGroupByPaymentMethod`;
};

export const dashboardCountUrl = () => {
    return `${apiUrl}/dashboard-count`;
};

export const dateOpenUrl = () => {
    return `${apiUrl}/date-open`;
};

export const dayCloseUrl = () => {
    return `${apiUrl}/date-close`;
};

export const getCurrentDayOpenUrl = () => {
    return `${apiUrl}/getCurrentDayOpen`;
};
export const categorySalesSummaryUrl = () => {
    return `${apiUrl}/category-sales-summary`;
};
export const creditSaleSummaryUrl = () => {
    return `${apiUrl}/credit-sale-summary`;
};
export const deleteTodayDayUrl = () => {
    return `${apiUrl}/delete-today-day`;
};
